//NOTE

// React
import React from 'react';

// Interface del usuario (GUI)
import { Col, Container, Row, Footer } from 'mdbreact';

const PiePagina = () => {
  return(
    <Footer color='green darken-4' className='bg-BarraNav-PiePag' >
        <Container className="text-left border-danger">
            <Row>
            <Col sm="6">
                <h5 className="title">Footer Content</h5>
            </Col>
            <Col sm="6">
                <h5 className="title">Links</h5>
                <ul>
                  <li className="list-unstyled"><a href="#!">Link 1</a></li>
                </ul>
            </Col>
            </Row>
        </Container>
        <div className="footer-copyright text-center">
            <Container fluid>
                &copy; {(new Date().getFullYear())} Todos los derechos reservados:  <a href="https://www.ciqpa.org"> ciqpacr.org </a>
            </Container>
        </div>
    </Footer>
    );
}
      
export default PiePagina


// WEBPACK FOOTER //
// ./src/layout/PiePagina.js